import script from "./Instalaciones.vue?vue&type=script&setup=true&lang=js"
export * from "./Instalaciones.vue?vue&type=script&setup=true&lang=js"

import "./Instalaciones.vue?vue&type=style&index=0&id=3b522a46&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b522a46"]])

export default __exports__